import { Modal, Text, Group, Button, Box } from '@mantine/core';
import type { HealthAlert } from '../../../../types';

interface ViewNotesModalProps {
  opened: boolean;
  onClose: () => void;
  alert: HealthAlert | null;
}

export function ViewNotesModal({ opened, onClose, alert }: ViewNotesModalProps) {
  if (!alert) return null;

  const resolutionLabel = alert.resolutionType === 'addressed' ? 'Addressed' : 'Dismissed';
  const formattedDate = alert.dismissedAt
    ? new Date(alert.dismissedAt).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : 'Unknown date';

  return (
    <Modal opened={opened} onClose={onClose} title="Notes" size="md">
      <Text fw={700} size="sm" mb={4}>
        {alert.title}
      </Text>
      <Text size="xs" c="dimmed" mb="md">
        {resolutionLabel} by {alert.dismissedByName ?? 'Unknown'} on {formattedDate}
      </Text>

      <Box
        p="sm"
        style={{
          border: '1px solid var(--mantine-color-gray-3)',
          borderRadius: 6,
          minHeight: 60,
        }}
      >
        {alert.dismissedNotes ? (
          <Text size="sm">{alert.dismissedNotes}</Text>
        ) : (
          <Text size="sm" c="dimmed" fs="italic">
            No notes recorded.
          </Text>
        )}
      </Box>

      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={onClose}>
          Close
        </Button>
      </Group>
    </Modal>
  );
}
